// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"bdad73c2","313":"c9f18a19","596":"2d4b5e0e"}[chunkId] + ".chunk.js";
};